module.exports = __webpack_public_path__ + "00bc6d6fd30cf56037536d6bb3ef80f7.svg";